// @ts-ignore
import { BondMath } from "@airdao/airdao-bond";
import { Token } from '../../../contexts/MarketsContext/provider.interface';
import { useMemo } from 'react';
import { utils } from 'ethers';
import { SDA } from '../../../utils/constants';
import useMarkets from '../../../contexts/MarketsContext/useMarkets';
import { formatDecimals } from '../../../utils/formatDecimals';

type MarketDataProps = {
  payoutToken?: Token,
  quoteToken?: Token,
  discount: number,
  quotePrice?: number,
  capacity: string,
  depositInterval: number,
  length: number,
  marketType: string,
}

const MarketData = ({ payoutToken, quoteToken, discount, quotePrice = 0, capacity, depositInterval, length, marketType }: MarketDataProps) => {
  const { tokens } = useMarkets();

  const marketInfo = useMemo(() => {
    if (!payoutToken || !quoteToken) {
      return {
        marketPrice: 0,
        askingPrice: 0,
        marketValue: 0,
      };
    }

    const marketPrice = (quotePrice === 0 ? quoteToken.price : quotePrice) / (payoutToken.price * (100 - discount) / 100);
    const askingPrice = quoteToken.price / marketPrice;

    return {
      marketPrice: payoutToken?.price,
      askingPrice: +askingPrice.toString(),
      marketValue: (+capacity * askingPrice / (quoteToken?.price || 0))
    }
  }, [payoutToken, quoteToken, discount, quotePrice, capacity]);

  const maxBondable = useMemo(() => {
    return +capacity * depositInterval / length;
  }, [capacity, depositInterval, length]);

  return (
    <>
      <p className="market-data-title">Market summary</p>
      <div className="market-data">
        {marketType !== SDA && (
          <div className="market-data__item">
            <p className="market-data__label">Asking price</p>
            <p className="market-data__value">${(marketInfo.askingPrice).toFixed(5)}</p>
          </div>
        )}
        <div className="market-data__item">
          <p className="market-data__label">Market price</p>
          <p className="market-data__value">${(+marketInfo.marketPrice).toFixed(5)}</p>
        </div>
        <div className="market-data__item">
          <p className="market-data__label">Market volume</p>
          <p className="market-data__value">
            {formatDecimals(capacity, payoutToken?.contractAddress, tokens)} {payoutToken?.symbol.toUpperCase()}
            <span className="market-data__price">${(+capacity * marketInfo.marketPrice).toFixed(2)}</span>
          </p>
        </div>
        <div className="market-data__item">
          <p className="market-data__label">Market value</p>
          <p className="market-data__value">
            {marketInfo.marketValue.toFixed(5)} {quoteToken?.symbol.toUpperCase()}
            <span className="market-data__price">${(marketInfo.marketValue * (quoteToken?.price || 0)).toFixed(2)}</span>
          </p>
        </div>
        <div className="market-data__item">
          <p className="market-data__label">Max bondable</p>
          <p className="market-data__value">
            {formatDecimals(maxBondable, payoutToken?.contractAddress, tokens)} {payoutToken?.symbol.toUpperCase()}
            <span className="market-data__price">
              ${(maxBondable * (payoutToken?.price || 0)).toFixed(2)}
            </span>

          </p>
        </div>
      </div>
    </>
  )
};

export default MarketData;
